import script from "./ConferenceProgram.vue?vue&type=script&setup=true&lang=js"
export * from "./ConferenceProgram.vue?vue&type=script&setup=true&lang=js"

import "./ConferenceProgram.vue?vue&type=style&index=0&id=d5f59b22&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5f59b22"]])

export default __exports__